module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ql-page-nav"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "disabled": !_vm.canPageDown
    },
    on: {
      "click": _vm.pageDown
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-number-container"
  }, [(_vm.pageNames[_vm.page - 1] && _vm.pageNames[_vm.page - 1].name) ? _c('input', {
    staticClass: "current-page-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.pageNames[_vm.page - 1].name
    },
    on: {
      "change": _vm.setPage
    }
  }) : _vm._e(), _vm._v(" / " + _vm._s(_vm._f("lastPageName")(_vm.pageNames)) + "\n    ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "disabled": !_vm.canPageUpDisplay
    },
    on: {
      "click": _vm.pageUp
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83fe7326","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/pagination.vue
// module id = 1272
// module chunks = 21